import {Component, OnInit, state, Input, SimpleChanges, ViewContainerRef, NgZone} from '@angular/core';
import {FormGroup, Validators, FormBuilder} from "@angular/forms";
import {Router} from "@angular/router";
import {AuthService} from "../shared/security/auth.service";
import {StateDataService} from "../shared/services/state/state-data.service";
import {Country} from "../shared/model/country";
import {State} from "../shared/model/state";
import {validateEmail} from "../shared/validators/validate-email"
import {RestaurantService} from "../shared/services/restaurant/restaurant.service";
import {Restaurant} from "../shared/model/restaurant";
import {Modal} from "angular2-modal/plugins/bootstrap";
import {Overlay} from 'angular2-modal';
import {User} from "../shared/model/user";
import {UserService} from "../shared/services/user/user.service";
import {MapsService} from "../shared/services/maps/maps.service";
import {_catch} from "rxjs/operator/catch";
import {TableService} from "../shared/services/table/table.service";


@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
  providers:[Modal]
})

export class RegisterComponent implements OnInit {
  private itHaveCode: boolean;


  // selectedCountry:Country = new Country(240,'United States','US');
  countries: Country[];
  states : State[];
  restaurant:Restaurant;
  user: User;
  fakeRestaurat : Restaurant;
  fakeUser:User;



  form:FormGroup;

  @Input()
  selectedState:string;
  selectorIsClicked:boolean;
  private ownerName: string;
  private edit: string = "";
  private latitude :string = "";
  private longitude : string = "";
  private createRestaurant$;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private stateDataservice : StateDataService,
    private restaurantService: RestaurantService,
    private userservice:UserService,
    private tableService:TableService,
    public modal: Modal,
    overlay: Overlay,
    vcRef: ViewContainerRef,
    private ms: MapsService


  ) {

    this.form = this.formBuilder.group({
      firstName:['',[Validators.required,Validators.minLength(4)]],
      lastName:['',[Validators.required,Validators.minLength(4)]],
      email:['',[Validators.required, validateEmail]],
      password:['',[Validators.required,Validators.minLength(8)]],
      confirm:['',Validators.required],
      restaurant:['',[Validators.required,Validators.minLength(3)]],
      address:['',[Validators.required,Validators.minLength(7)]],
      city:['',[Validators.required,Validators.minLength(3)]],
      state:['',Validators.required],
      zip:['',[Validators.required,Validators.minLength(5)]],
      latitude:['',[Validators.required,Validators.minLength(4)]],
      longitude:['',[Validators.required,Validators.minLength(4)]],
      agreed:[false, Validators.pattern('true')]
    });

    this.countries = this.stateDataservice.getCountries();

    this.states = this.stateDataservice.getStates();

    this.selectorIsClicked = false;

    overlay.defaultViewContainer = vcRef;

    this.user = Object.assign({});

    this.restaurant = Object.assign({});



  }

  onGetLocation() {
    let addressIsValid =
      this.form.controls['address'].valid &&
      this.form.controls['city'].valid &&
      this.form.controls['state'].valid &&
      this.form.controls['zip'].valid;

    if (addressIsValid){
      let address = this.form.controls['address'].value + ' '+
        this.form.controls['city'].value + ' '+
        this.form.controls['state'].value + ' '+
        this.form.controls['zip'].value;
      address = encodeURI(address);
      this.getLatLan(address);
    }
  }

  getLatLan(address: string) {

    const coord$ = this.ms.getLocation( address );
    coord$.subscribe( result =>{
        this.form.controls['latitude'].setValue( result.lat)
        this.form.controls['longitude'].setValue( result.lng)
        this.select(result.state);
        this.selectorIsClicked = true;
        this.form.controls['state'].markAsDirty();
        // result => console.log(result)
      }
    );


  }

  ngOnInit() {

    this.authService.logout();

    const singAnonym$ = this.authService.anonymously();
    singAnonym$
      .subscribe((res) => {
    });

    this.selectedState = "Select a state";

    this.itHaveCode = false;

    /*
     this.messageBody = "Message Body";
     this.messageTitle = "Message Title";
     */
    // DONE: Remove latter (only for Testing Purpose
    //    this.initialiseForm();


  }

  initialiseForm(){

    let myRandom = Math.random() * (2 - 50) + 1;
    myRandom = Math.round(myRandom);

    this.form.controls['restaurant'].setValue( "TESTING REGISTER");
    this.form.controls['address'].setValue( "3252 SW Palm West Ct");
    this.form.controls['city'].setValue( "Stuart");
    this.form.controls['state'].setValue( "Florida");
    this.form.controls['zip'].setValue( "35246");
    this.form.controls['agreed'].setValue( true);
    this.form.controls['firstName'].setValue( "Barbara");
    this.form.controls['lastName'].setValue( "Pierce");
    this.form.controls['email'].setValue( "bbr"+myRandom+"@luissalcedo.com");
    this.form.controls['password'].setValue( "password");
    this.form.controls['confirm'].setValue( "password");
    // this.select('Florida');
    // this.selectorIsClicked = true;
    // this.form.controls['state'].markAsDirty();

  }

  register(){



    const isValid = this.form.valid;


    if (isValid){




    this.restaurant.restaurant = this.form.value.restaurant;
    this.restaurant.address = this.form.value.address;
    this.restaurant.city = this.form.value.city;
    this.restaurant.state = this.form.value.state;
    this.restaurant.zip = this.form.value.zip;
    this.restaurant.isActive = true;
    this.restaurant.edit = "<span class=\"glyphicon glyphicon-edit\"></span>";
    this.restaurant.agreed = true;
    this.restaurant.latitude = this.form.value.latitude;
    this.restaurant.longitude = this.form.value.longitude;

    this.user.first = this.form.value.firstName;
    this.user.last = this.form.value.lastName;
    this.user.nickName = this.form.value.firstName;
    this.user.isActive = true;
    this.user.email = this.form.value.email;



    let ownerName = this.form.value.firstName + ' '+ this.form.value.lastName;

       const userCreated$ = this.authService.createUser(this.form.value.email,this.form.value.password,ownerName);
        userCreated$
          .subscribe((user) =>
          // TODO: Send User

            {
              // console.log(user);
              this.user.sysUid = user.uid;
              this.authService.sendVerificationEmmail().subscribe(
                ()=>{
                   // console.log("Sending Verification Email!");
                  this.authService.updateProfileName(ownerName).subscribe(
                    ()=>{
                      // console.log("Updating Profile!");
                      this.createUser();
                    }
                  )
                }
              )



            }
          , err => this.messageIt('Error creating user ',err)
          )



    } else {

      this.showErrors();

    }

  }

  private createUser(){

    const newUser$ = this.userservice.createUser(this.user);
    newUser$
      .subscribe(
        (user)=>
        {
          // console.log("Getting user Key");
          this.getUserKey(this.user.sysUid);
        }
        ,err => this.messageIt('Error creating user ',err)
        );

  }

  private getUserKey(userID){
    const getUserKey$ = this.userservice.getUser(userID);
    getUserKey$
    .subscribe((user) => {
      // this.createStripeUser(user.$key);
      // console.log("Creating Restaurant");
      this.createRestaurant(user.$key,user.email);
      });

  }

  private createRestaurant(userkey,email){

    this.createRestaurant$  = this.restaurantService.createNewRestaurant(this.restaurant,userkey,email)
      .subscribe(() => {
      // console.log("Navigating Out! ");
        this.logOutAndNavigate();
        }
      );
  }



  showErrors(){

    for (let element in this.form.controls){
      for(let element1 in  this.form.controls[element].errors){
        this.form.controls[element].markAsDirty();
      }
    }
    if (this.selectedState === "Select a state"){
      this.selectorIsClicked = true;
      this.form.controls['state'].markAsDirty();
    }

  }

  private logOutAndNavigate() {
    this.createRestaurant$.unsubscribe();
    this.confirmNeedToVerify();
  }

  logout(){
    this.authService.setShow(false);
    // this.tableService.tableDisconnect();
    // this.restaurantService.restaurantDisconnect();
    this.router.navigate(['/home']);

  }


  confirmNeedToVerify(){

    this.modal.alert()
      .size('lg')
      .isBlocking(true)
      .showClose(false)
      .keyboard(27)
      .title('Verify your email')
      .body('Please check your Mailbox for a Verification mail from SRVPLS !')
      .okBtn('OK')
      .open()
      .catch((err: any) => console.log('ERROR: ' + err))
      .then((dialog: any) => {return dialog.result; })
      .then((result: any) => {
      // this.authService.logout();
      this.logout();
    })

  }

  printOpening() {

  }

  printClosing() {

    this.selectorIsClicked = true;
  }

  clicked(){

    this.selectorIsClicked = true;
  }

  select(selectedState:string) {

    this.selectedState = selectedState;
    this.form.controls['state'].setValue(selectedState);
    // this.form.controls['state'].setErrors(null);

  }

  agreeding(){

    const val = this.form.value;
    const agree = val.agreed;
  }

  isPasswordMatch(){
    const val = this.form.value;
    const itMatch = val && val.password && val.password == val.confirm
    return itMatch;
  }

  itHaveErrors(){

    const isValid = this.form.valid;

    return isValid;

  }

  itMatch(){
    const val = this.form.value;
    const itMatch = val.password == val.confirm
    return itMatch;
  }

  showSelectorError(){
    const showError = this.selectedState == "Select a state" && this.selectorIsClicked;

    return showError;
  }

  ngOnChanges(changes:SimpleChanges){

    if (this.form && changes['initialValues']){
      this.form.patchValue(changes['initialValues'].currentValue);
    }

  }

  isErrorVisible(field:string,error:string){

    return this.form.controls[field].dirty && this.form.controls[field].errors && this.form.controls[field].errors[error];

  }

  reset() {
    this.form.reset();

    this.selectedState = "Select a state";
    // this.form.controls['isActive'].setValue(true);
    this.selectorIsClicked = false;
  }

  get valid(){
    return this.form.valid;
  }

  get value(){
    return this.form.value;
  }

  messageIt(titleP:string,messageP:string){

    this.modal.alert()
      .size('lg')
      .showClose(true)
      .title(titleP)
      .body(messageP)
      .open();
  }

  close() {
    // this.modal.close();
  }

  openTerms(){

    this.messageIt('Terms of Service ("Terms")',
      `
    <p>Last updated: December 27, 2016</p>
    <p>Please read these Terms of Service ("Terms", "Terms of Service") carefully before using the SRVPLS website (the "Service") operated by SRVPLS ("us", "we", or "our").</p>
    <p>Your access to and use of the Service is conditioned on your acceptance of and compliance with these Terms. These Terms apply to all visitors, users and others who access or use the Service.</p>
    <p>By accessing or using the Service you agree to be bound by these Terms. If you disagree with any part of the terms then you may not access the Service.

        <p><strong>Accounts</strong></p>
        <p>When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.</p>
        <p>You are responsible for safeguarding the password that you use to access the Service and for any activities or actions under your password, whether your password is with our Service or a third-party service.</p>
        <p>You agree not to disclose your password to any third party. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</p>
        <p><strong>Links To Other Web Sites</strong></p>
        <p>Our Service may contain links to third-party web sites or services that are not owned or controlled by SRVPLS.</p>
        <p>SRVPLS has no control over, and assumes no responsibility for, the content, privacy policies, or practices of any third party web sites or services. You further acknowledge and agree that SRVPLS shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with use of or reliance on any such content, goods or services available on or through any such web sites or services.</p>
        <p>We strongly advise you to read the terms and conditions and privacy policies of any third-party web sites or services that you visit.</p>
        <p><strong>Termination</strong></p>
        <p>We may terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
        <p>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>
        <p>We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms.</p>
        <p>Upon termination, your right to use the Service will immediately cease. If you wish to terminate your account, you may simply discontinue using the Service.</p>
        <p>All provisions of the Terms which by their nature should survive termination shall survive termination, including, without limitation, ownership provisions, warranty disclaimers, indemnity and limitations of liability.</p>
        <p><strong>Governing Law</strong></p>
        <p>These Terms shall be governed and construed in accordance with the laws of Florida, United States, without regard to its conflict of law provisions.</p>
        <p>Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have between us regarding the Service.</p>
        <p><strong>Changes</strong></p>
        <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material we will try to provide at least 30 days notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>
        <p>By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, please stop using the Service.</p>
        <p><strong>Contact Us</strong></p>
        <p>If you have any questions about these Terms, please contact us.</p>
  
      `
    );
  }

  closeTerms() {
    // this.modal2.close();
  }




}



// WEBPACK FOOTER //
// ./src/app/register/register.component.ts